import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay, 
  cibCcAmex
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilFeaturedPlaylist,
  cilNewspaper,
  cilListRich,
  cilRunning,
  cilVolumeHigh,
  cilBriefcase,
  cilWc,
  cilBarChart,
  cilChevronLeft,
  cilChevronRight,
  cilLoopCircular,
  cilSend,
  cilGroup,
  cilApps,
  cilHome,
  cilGrain,
  cilChart,
  cilBraille,
  cilContrast,
  cilZoom,
  cilTag,
  cilIndustry,
  cilRestaurant,
  cilBlur,
  cilChartLine,
  cilCamera,
  cilDescription,
  cilContact,
  cilPrint,
  cilSpreadsheet,
  cilUserPlus,
  cilArrowRight,
  cilBan,
  cilBasket,
  cilBell,
  cilBank,
  cilBuilding,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle

} from '@coreui/icons'
import { logo } from './logo'

export const iconsSet = Object.assign(
  {},
  { logo },
  {
    cilFeaturedPlaylist,
    cilNewspaper,
    cilListRich,
    cilRunning,
    cilVolumeHigh,
    cilBriefcase,
    cilWc,
    cilBarChart,
    cilChevronLeft,
    cilChevronRight,
    cilLoopCircular,
    cilSend,
    cilGroup,
    cilApps,
    cilHome,
    cilGrain,
    cilChart,
    cilBraille,
    cilContrast,
    cilZoom,
    cilTag,
    cilIndustry,
    cilRestaurant,
    cilBlur,
    cilChartLine,
    cilCamera,
    cilDescription,
    cilContact,
    cilUserPlus,
    cilSpreadsheet,
    cilPrint,
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilBank,
    cilBuilding,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard, 
    cibCcVisa, 
    cibStripe, 
    cibPaypal, 
    cibGooglePay,
    cibCcAmex
  }
)
